/**
 * Toggle classes
 * @module cookiesBanner
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'cookiesBanner';

let userHasScrolled = false;
const $html = $('html');


export const DEFAULTS = {
  trapFocusFunc: Keyboard.trapFocus.bind(Keyboard),
  releaseFocusFunc: Keyboard.releaseFocus.bind(Keyboard),
};

const handleToggle = ($cookieBanner, $contentToShow, $contentToHide, activeClass, opts) => {
  const $el = $('.js-cookies-banner-toggle');
  const startingHeight = $cookieBanner[0].offsetHeight;
  $cookieBanner.css('height', startingHeight);
  if (activeClass) {
    $cookieBanner.removeClass('active');
    $el.attr('aria-expanded', 'false');
    $cookieBanner.attr('aria-modal', 'false');
    $cookieBanner.removeAttr('role', 'dialog');
    if ($html.hasClass('focus-active')) {
      opts.releaseFocusFunc($cookieBanner);
    }
  } else {
    $cookieBanner.addClass('active');
    $el.attr('aria-expanded', 'true');
    $cookieBanner.attr('aria-modal', 'true');
    $cookieBanner.attr('role', 'dialog');
    if ($html.hasClass('focus-active')) {
      opts.trapFocusFunc($cookieBanner);
    }
  }
  const newHeight = $contentToShow[0].offsetHeight + 22;
  $cookieBanner.animate({ height: newHeight }, 300);
};

const handleClick = ($cookieBanner, $initialContent, $newContent, opts) => {
  const hasActiveClass = $cookieBanner.hasClass('active');
  if (hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true, opts);
  } else {
    handleToggle($cookieBanner, $newContent, $initialContent, false, opts);
  }
};

const handleScroll = (scrollPosY, $cookieBanner, $initialContent, $newContent, opts) => {
  const hasActiveClass = $cookieBanner.hasClass('active');
  if (!userHasScrolled && scrollPosY !== 0 && hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true, opts);
    userHasScrolled = true;
  }
};

/**
 * Applies any sort of event handlers for the cookiesBanner.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, opts) => {
  const $cookieBanner = $el.closest('.cookies-banner');
  const $initialContent = $('.cookies-banner__head');
  const $newContent = $('.cookies-banner__details--v2');

  $el.on('keydown', (evt) => {
    const hasActiveClass = $cookieBanner.hasClass('active');
    if (Keyboard.parseKey(evt) === Keyboard.keys.ESCAPE) {
      if (hasActiveClass) {
        handleToggle($cookieBanner, $initialContent, $newContent, true, opts);
      } else {
        handleToggle($cookieBanner, $initialContent, $newContent, false, opts);
      }
    }
  });

  $el.on('click', () => {
    handleClick($cookieBanner, $initialContent, $newContent, opts);
  });

  $(window).on('scroll resize', () => {
    const scrollPosY = $(window).scrollTop();
    handleScroll(scrollPosY, $cookieBanner, $initialContent, $newContent, opts);
  });
};
/**
 * Initializes cookiesBanner.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function cookiesBanner(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, cookiesBanner);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/cookies-banner.js